const loadedImages = new Set();
const loadingImages = new Map();

export function preloadImage(url, priority = 'auto') {
  if (!url || loadedImages.has(url) || loadingImages.has(url)) {
    return loadingImages.get(url) || Promise.resolve();
  }

  const promise = new Promise((resolve) => {
    const img = new Image();
    if ('fetchPriority' in img && priority === 'high') {
      img.fetchPriority = 'high';
    }
    if ('decoding' in img) {
      img.decoding = 'async';
    }
    img.onload = () => {
      loadedImages.add(url);
      loadingImages.delete(url);
      resolve(url);
    };
    img.onerror = () => {
      loadingImages.delete(url);
      resolve(null);
    };
    img.src = url;
  });

  loadingImages.set(url, promise);
  return promise;
}

export function preloadImages(urls, options = {}) {
  const { priority = 'auto', limit } = options;
  const uniqueUrls = [...new Set(urls.filter(Boolean))];
  const batch = typeof limit === 'number' ? uniqueUrls.slice(0, limit) : uniqueUrls;
  return Promise.all(batch.map((url) => preloadImage(url, priority)));
}

export function preloadImagesIdle(urls, options = {}) {
  const run = () => preloadImages(urls, options);

  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(run, { timeout: 2500 });
    return;
  }

  setTimeout(run, 300);
}
